<lib-breadcrumb [list]="breadcrumbs()"></lib-breadcrumb>
<div class="text-lg mb-5">My Tasks</div>
  <div class="container mt-4" *ngIf="!isLoadingAll">
    
    <div>
      <div class="header mat-mdc-header-row text-black p-2 flex justify-between items-center cursor-pointer" (click)="toggleCasesExpand()">
        <h3 class="text-lg font-normal">Cases</h3>
        <mat-icon>{{ isCasesExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </div>
      <div *ngIf="isCasesExpanded" class="mt-2">
        <table class="w-full border-collapse border border-gray-300">
          <thead>
            <tr class="calender-header-tab-col text-black text-left text-sm font-normal">
              <th class="p-2 border font-normal text-black-500">ID</th>
              <th class="p-2 border font-normal text-black-500">Case Number</th>
              <th class="p-2 border font-normal text-black-500">Court Name</th>
              <th class="p-2 border font-normal text-black-500">Plaintiff(s)/Claimant(s)/Appellant(s)</th>
              <th class="p-2 border font-normal text-black-500">Defendant(s)/Respondent(s)</th>
              <th class="p-2 border font-normal text-black-500">Documents</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let caseItem of cases" class="even:bg-gray-100 odd:bg-white text-gray-700 text-sm">
              <td class="p-2 border">{{ caseItem.caseId }}</td>
              <td class="p-2 border">{{ caseItem.caseNumber }}</td>
              <td class="p-2 border">{{ caseItem.courtUnitTypeName }}</td>
              <td class="p-2 border">{{ caseItem.partiesByPrtIdIssuedBy }}</td>
              <td class="p-2 border">{{ caseItem.partyIdCharging }}</td>
              <td class="p-2 border text-blue-600 cursor-pointer"><a href="javascript:void(0)" (click)="goToListOfFiles(caseItem)" class="doc-link">
                File
              </a></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="mt-4">
      <div class="header mat-mdc-header-row text-black p-2 flex justify-between items-center cursor-pointer" (click)="toggleTasksExpand()">
        <h3 class="text-lg font-normal">Tasks</h3>
        <mat-icon>{{ isTasksExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </div>
      <div *ngIf="isTasksExpanded" class="mt-2">
        <table class="w-full border-collapse border border-gray-300">
          <thead>
            <tr class="calender-header-tab-col text-black text-left text-sm font-normal">
              <th class="p-2 border font-normal text-black-500">ID</th>
              <th class="p-2 border font-normal text-black-500">Due</th>
              <th class="p-2 border font-normal text-black-500">Case Number</th>
              <th class="p-2 border font-normal text-black-500">Done</th>
              <th class="p-2 border font-normal text-black-500">Task Details</th>
              <th class="p-2 border font-normal text-black-500">Task Type Id</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let taskItem of tasks" class="even:bg-gray-100 odd:bg-white text-gray-700 text-sm">
              <td class="p-2 border">{{ taskItem.tasksId }}</td>
              <td class="p-2 border">{{ taskItem.tasksDue }}</td>
              <td class="p-2 border">{{ taskItem.caseCourtCaseNumber }}</td>
              <td class="p-2 border">{{ taskItem.tasksDone }}</td>
              <td class="p-2 border">{{ taskItem.tasksDetails }}</td>
              <td class="p-2 border">{{ taskItem.taskTypeId }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="mt-4">
        <div class="header mat-mdc-header-row text-black p-2 flex justify-between items-center cursor-pointer" (click)="toggleRemindersExpand()">
          <h3 class="text-lg font-normal">Reminders</h3>
          <mat-icon>{{ isRemindersExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>
        <div *ngIf="isRemindersExpanded" class="mt-2">
          <table class="w-full border-collapse border border-gray-300">
            <thead>
              <tr class="calender-header-tab-col text-black text-left text-sm font-normal">
                <th class="p-2 border font-normal text-black-500">ID</th>
                <th class="p-2 border font-normal text-black-500">Due</th>
                <th class="p-2 border font-normal text-black-500">Case Number</th>
                <th class="p-2 border font-normal text-black-500">Done</th>
                <th class="p-2 border font-normal text-black-500">Reminders Details</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let reminderItem of reminders" class="even:bg-gray-100 odd:bg-white text-gray-700 text-sm">
                <td class="p-2 border">{{ reminderItem.remindersId }}</td>
                <td class="p-2 border">{{ reminderItem.remindersDue }}</td>
                <td class="p-2 border">{{ reminderItem.remindersCaseNumber }}</td>
                <td class="p-2 border">{{ reminderItem.remindersDone }}</td>
                <td class="p-2 border">{{ reminderItem.remindersDetails }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="mt-4">
        <div class="header mat-mdc-header-row text-black p-2 flex justify-between items-center cursor-pointer" (click)="toggleNotificationsExpand()">
          <h3 class="text-lg font-normal">Notifications</h3>
          <mat-icon>{{ isNotificationsExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>
        <div *ngIf="isNotificationsExpanded" class="mt-2">
          <table class="w-full border-collapse border border-gray-300">
            <thead>
              <tr class="calender-header-tab-col text-black text-left text-sm font-normal">
                <th class="p-2 border font-normal text-black-500">ID</th>
                <th class="p-2 border font-normal text-black-500">Due</th>
                <th class="p-2 border font-normal text-black-500">Case Number</th>
                <th class="p-2 border font-normal text-black-500">Done</th>
                <th class="p-2 border font-normal text-black-500">Notification Details</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let notificationItem of notifications" class="even:bg-gray-100 odd:bg-white text-gray-700 text-sm">
                <td class="p-2 border">{{ notificationItem.notificationsId }}</td>
                <td class="p-2 border">{{ notificationItem.notificationsDue }}</td>
                <td class="p-2 border">{{ notificationItem.notificationsCaseNumber }}</td>
                <td class="p-2 border">{{ notificationItem.notificationsDone }}</td>
                <td class="p-2 border">{{ notificationItem.notificationsDetails }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
  </div>
  <div *ngIf="isLoadingAll" class="flex justify-center items-center h-48">
  <mat-spinner diameter="40"></mat-spinner>
</div>
  